<template>
  <div class="flex flex-col justify-center items-center">
    <div class="block p-10 w-full text-start max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
      <h5 class="mb-4 text-center text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Forgot Password</h5>
      <div v-if="!isSent">
        <form @submit.prevent="handleForgotPassword">
          <div class="mb-6">
            <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Your email</label>
            <input v-model="user.email" type="email" id="email" class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" required>
          </div>
          <div class="validationError mb-6">
            <span v-for="error in errors" :key="error" v-html="error" class="text-sm font-medium text-gray-900 dark:text-gray-400"></span>
          </div>
          <div class="mb-4 text-center">
            <button v-if="!loading" :disabled="loading" type="submit" class="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Send Reset Link</button>
            <button v-else :disabled="loading" type="submit" class="opacity-50 cursor-auto w-full text-white bg-blue-700 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700">Send Reset Link</button>
          </div>
          <div class="text-center">
            <span class="text-sm font-medium text-gray-900 dark:text-gray-400"><a @click="goToLogin">Back to Login</a></span>
          </div>
        </form>
      </div>
      <div v-else>
        <div class="mb-4 text-center">
          <span class="text-sm font-medium text-gray-900 dark:text-gray-400">Your password reset link has been sent to <strong>{{user.email}}</strong>. Please check your email box.</span>
        </div>
        <div class="mb-2 text-center">
            <button @click="goToHomePage" type="button" class="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Go To Home Page</button>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from '../services/auth.service';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      user: {
        email: ''
      },
      loading: false,
      isSent: false,
      errors: []
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
    
  },
  mounted() {
  },
  methods: {
    handleForgotPassword() {
        this.errors = [];
        if(this.user.email === ''){
          this.errors.push("- Email must be given(*)<br>");
        }else if(!this.validEmail(this.user.email)){
          this.errors.push("- Email must be valid(*)<br>");
        }
        if(this.errors.length === 0)
        {
          this.loading = true;

          AuthService.forgotPassword(this.user.email).then(
          response => {
            if(response)
            {
              this.contactForm = {};
              this.isSent = true;
            }else{
              this.loading = false;
            }
          },
          error => {
            this.content =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
              this.loading = false;
          }
        );
        }
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    goToHomePage() {
      this.$router.push('/');
    },
    goToLogin() {
      this.$router.push('/login');
    },
  }
};
</script>

<style scoped>
.validationError{
  text-align: left;
  font-size: 12px;
  font-weight: 500;
}

.input-icons i {
	position: absolute;
}
	
.input-icons {
	width: 100%;
	margin-bottom: 10px;
}
	
.icon {
	padding: 18px;
	color: #ababab;
	min-width: 50px;
	text-align: center;
}

.login-header{
	font-size: 24px;
	font-weight: bold;
}

.login-text{
	margin-bottom:30px;
	font-size: 14px;
	color:#666666;
}

.login-page {
  width: 500px;
  padding: 0;
  margin: auto;
}
.form {
  position: relative;
  z-index: 1;
  background: #FFFFFF;
  max-width: 500px;
  margin: auto;
  padding: 45px;
  text-align: center;
  border: 1px solid #ebebeb;
  border-radius: 10px;
}
.form input {
  outline: 0;
  background: #ffffff;
  width: 100%;
  border: 1px solid #ebebeb;
  margin: 0 0 15px;
  padding: 15px 45px;
  box-sizing: border-box;
  font-size: 14px;
  border-radius: 5px;
}
.form button {
font-weight: bold;
  outline: 0;
  background:rgb(55, 147, 233);
  width: 100%;
  border: 0;
  padding: 10px;
  color: #FFFFFF;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
  border-radius: 5px;
}
.form button:hover,.form button:active,.form button:focus {
  background: rgb(14, 125, 230);
}
.form .message {
  margin: 15px 0 0;
  color: #b3b3b3;
  font-size: 12px;
}
.form .message a {
  color:rgb(55, 147, 233);
  text-decoration: none;
}
.form .register-form {
  display: none;
}
.container {
  position: relative;
  z-index: 1;
  max-width: 300px;
  margin: 0 auto;
}
.container:before, .container:after {
  content: "";
  display: block;
  clear: both;
}
.container .info {
  margin: 50px auto;
  text-align: center;
}
.container .info h1 {
  margin: 0 0 15px;
  padding: 0;
  font-size: 36px;
  font-weight: 300;
  color: #1a1a1a;
}
.container .info span {
  color: #4d4d4d;
  font-size: 12px;
}
.container .info span a {
  color: #000000;
  text-decoration: none;
}
.container .info span .fa {
  color: #EF3B3A;
}
body {
  background: #76b852 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(right, #76b852, #8DC26F);
  background: -moz-linear-gradient(right, #76b852, #8DC26F);
  background: -o-linear-gradient(right, #76b852, #8DC26F);
  background: linear-gradient(to left, #76b852, #8DC26F);
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;      
}

</style>